import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-77">
      {/* Constellation Overlay (SVG) */}
      <div className="absolute inset-0 pointer-events-none opacity-20" data-id="element-78">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-79">
          <motion.path d="M100,200 L300,150 L500,300 L700,100 L900,250" stroke="cyan" strokeWidth="1" fill="none" initial={{
          pathLength: 0,
          opacity: 0
        }} animate={{
          pathLength: 1,
          opacity: 1
        }} transition={{
          duration: 3,
          ease: 'easeInOut'
        }} data-id="element-80" />
          <circle cx="100" cy="200" r="2" fill="white" data-id="element-81" />
          <circle cx="300" cy="150" r="2" fill="white" data-id="element-82" />
          <circle cx="500" cy="300" r="2" fill="white" data-id="element-83" />
          <circle cx="700" cy="100" r="2" fill="white" data-id="element-84" />
          <circle cx="900" cy="250" r="2" fill="white" data-id="element-85" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-87">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-900/30 border border-cyan-500/30 text-cyan-300 text-sm mb-8 backdrop-blur-sm" data-id="element-88">
            <Star className="w-3 h-3 fill-current" data-id="element-89" />
            <span data-id="element-90">Stargazing Reimagined</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-heading font-bold text-white mb-6 tracking-tight leading-tight drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]" data-id="element-91">
            Navigate the Cosmos <br data-id="element-92" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-blue-500" data-id="element-93">
              With Precision
            </span>
          </h1>

          <p className="mt-4 max-w-2xl mx-auto text-xl text-slate-300 leading-relaxed" data-id="element-94">
            Starkeep brings professional-grade stargazing tools, real-time
            celestial tracking, and a passionate community to astronomers
            everywhere.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-95">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-cyan-500 text-white rounded-full font-medium text-lg shadow-[0_0_20px_rgba(6,182,212,0.4)] hover:shadow-[0_0_30px_rgba(6,182,212,0.6)] transition-all flex items-center gap-2" data-id="element-96">
              Explore the Sky
              <ArrowRight className="w-5 h-5" data-id="element-97" />
            </motion.button>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-transparent border border-slate-600 text-slate-200 rounded-full font-medium text-lg hover:bg-slate-800/50 hover:border-slate-500 transition-all backdrop-blur-sm" data-id="element-98">
              View Plans
            </motion.button>
          </div>
        </motion.div>
      </div>

      {/* Decorative gradient glow at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0e27] to-transparent z-10" data-id="element-99" />
    </section>;
}